import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import AdFormatsTabs, { AdFormatsEnum } from '@src/components/AdFormatsTab';

import { videoList } from '../constant';

import './index.scss';

const AdFormats = () => {
  const [activeTab, setActiveTab] = useState(AdFormatsEnum.Rewarded);
  const [loadedVideos, setLoadedVideos] = useState<Set<AdFormatsEnum>>(new Set());

  const handleVideoLoaded = (type: AdFormatsEnum) => {
    setLoadedVideos(prev => new Set(prev).add(type));
  };
  return (
    <div className="odc-page-ad-formats">
      <div className="ad-formats-enum">
        <div className="ad-formats-slogan">
          <div className="title">Designed for Profitable Growth.</div>
          <div className="sub-title">Built Around Your Needs.</div>
          <div className='desc'>Delivering intuitive ad formats for every in-app moment — crafted for seamless experiences. </div>
        </div>
        <AdFormatsTabs
          onTabChange={(tab: AdFormatsEnum) => {
            setActiveTab(tab);
          }}
        />
      </div>
      <div className="ad-formats-playground">
        <div className="ad-formats-video">
          {videoList.map(({ type, video, poster }) => {
            const isActive = activeTab === type;
            const isLoaded = loadedVideos.has(type);
            return (
              <div
                key={type}
                className={`video-wrapper ${isActive ? 'active' : 'inactive'}`}
              >
                {activeTab === type && (
                  <div className={classNames('video-frame', { loaded: isLoaded })}>
                    <video
                      className="video-item"
                      src={video}
                      poster={poster}
                      autoPlay={isActive}
                      loop
                      muted
                      preload="auto"
                      playsInline
                      onCanPlay={() => handleVideoLoaded(type)}
                      onLoadedData={() => handleVideoLoaded(type)}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <div className='ad-format-background-bar'></div>
    </div>
  );
};

export default AdFormats;